import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./CategoryProducts.css";
import { wishlistUtils } from "../utils/userCartWishlistUtils";
import ProgressLoader from "../Loader/ProgressLoader";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { LuSearchX } from "react-icons/lu";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";

const CategoryProducts = () => {
  const { CategoryID } = useParams();
  const navigate = useNavigate();
  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState(CategoryID || "1");
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    setActiveCategory(CategoryID);
  }, [CategoryID]);

  useEffect(() => {
    if (products.length > 0) {
      const initialWishlistStatus = {};

      products.forEach((product) => {
        initialWishlistStatus[product.id] = wishlistUtils.isInWishlist(
          product.id
        );
      });

      setWishlistStatus(initialWishlistStatus);
    }
  }, [products]);


  const fetchSubCategories = async () => {
    try {
      const response = await axios.get(
        `https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_SubCategory_SubCategoryList?categoryId=${activeCategory}`
      );
      setSubCategories(response.data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList?categoryId=${activeCategory}`
      );
      setProducts(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeCategory) {
      setLoading(true);
      fetchSubCategories();
      fetchProducts();
    }
  }, [activeCategory]);

  const handleSeeAllClick = (subCategoryId, subCategoryName) => {
    navigate(`/seeall/${subCategoryId}`, {
      state: {
        subCategoryName,
        categoryId: activeCategory,
      },
    });
  };
  const handleWishlistToggle = async (productId) => {
    if (wishlistStatus[productId]) {
      const success = await wishlistUtils.removeFromWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: false,
        }));
      }
    } else {
      const success = await wishlistUtils.addToWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: true,
        }));
      } else {
        setShowAlert(true);
      }
    }
  };
  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };
  const productsBySubCategory = subCategories.reduce((acc, subCategory) => {
    const subCategoryProducts = products.filter(
      (product) => product.subCategoryId === subCategory.id
    );
    if (subCategoryProducts.length > 0) {
      acc[subCategory.id] = {
        name: subCategory.subCategoryName,
        products: subCategoryProducts,
      };
    }
    return acc;
  }, {});

  if (loading) {
    return (
      <div className="home-category-container">
        {[1, 2, 3].map((_, i) => (
          <div key={i} className="home-subcategory-section">
            
            <div className="subcategory-header">
              <div className="skeleton-shimmer skeleton-line medium" style={{ height: "20px" }}></div>
              <div className="skeleton-shimmer skeleton-line short" style={{ height: "20px" }}></div>
            </div>

            <div className="home-products-scroll-container">
              <div className="home-products-scroll">
                {Array(8).fill(0).map((_, idx) => (
                  <SkeletonLoader key={idx} />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      <div className="category-products-container">
        {(() => {
          // Filter only subcategories that have products
          const validSubcategories = Object.entries(productsBySubCategory).filter(
            ([_, { products }]) => products && products.length > 0
          );

          // If no subcategory has products → show message
          if (validSubcategories.length === 0) {
            return (
              <div className="no-products-global enhanced-no-products">
                <LuSearchX size={60} className="no-products-icon" />
                <h3 className="no-products-title">No Products Found</h3>
                <p className="no-products-text">
                  Looks like nothing is available here right now.
                </p>
              </div>
            );
          }

          // Otherwise, render only subcategories that contain products
          return validSubcategories.map(
            ([subCategoryId, { name, products }]) => (
              <div key={subCategoryId} className="category-subcategory-section">
                <div className="category-subcategory-header">
                  <h2 className="category-subcategory-title">{name}</h2>
                  <button
                    className="category-see-all-btn"
                    onClick={() => handleSeeAllClick(subCategoryId, name)}
                  >
                    See All
                  </button>
                </div>

                <div className="category-products-scroll-container">
                  <div className="category-products-scroll">
                    {products.map((product) => (
                      <div key={product.id} className="category-product-card">
                        <div
                          className="category-product-image-container"
                          onClick={() => handleProductClick(product)}
                        >
                          <img
                            src={
                              product.productImage
                                ? `https://api.dremerz.net/uploads/${product.productImage}`
                                : "/default-product.jpg"
                            }
                            loading="lazy"
                            alt={product.brandName}
                            className="category-product-image"
                          />

                          {product.tags && (
                            <span className="category-product-tag">
                              {product.tags}
                            </span>
                          )}
                        </div>

                        <div className="category-product-info">
                          <h3
                            className="m-0 category-product-brandname"
                            onClick={() => handleProductClick(product)}
                          >
                            {product.brandName}
                          </h3>

                          <p className="category-product-name m-0">
                            {product.productName}
                          </p>

                          <div className="category-product-price m-0">
                            <span className="category-current-price">
                              ₹{product.sellingPrice}
                            </span>

                            {product.originalPrice && (
                              <>
                                <span className="category-original-price">
                                  ₹{product.originalPrice}
                                </span>
                                <span className="category-offer">
                                  {" "}
                                  (
                                  {Math.round(
                                    ((product.originalPrice - product.sellingPrice) /
                                      product.originalPrice) *
                                      100
                                  )}
                                  % OFF)
                                </span>
                              </>
                            )}
                          </div>

                          <div className="category-product-actions">
                            <button
                              className={`category-action-btn category-wishlist-btn ${
                                wishlistStatus[product.id]
                                  ? "category-in-wishlist"
                                  : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleWishlistToggle(product.id);
                              }}
                            >
                              {wishlistStatus[product.id] ? <FaHeart /> : <FaRegHeart />}
                              {wishlistStatus[product.id]
                                ? " Wishlisted"
                                : " Wishlist"}
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          );
        })()}

        {/* Login Alert Modal */}
        {showAlert && (
          <div className="category-modal-overlay">
            <div className="category-modal-content">
              <h3>Login Required</h3>
              <p>Please login to add items to your wishlist.</p>
              <div className="category-modal-actions">
                <button
                  className="category-btn-cancel"
                  onClick={() => setShowAlert(false)}
                >
                  Cancel
                </button>
                <button
                  className="category-btn-login"
                  onClick={() => navigate("/login")}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CategoryProducts;